(() => {
  'use strict';
  // Conta como conversão do Google Ads todo clique em link de WhatsApp do site.
  // Os botões das páginas de Assistência e Locação já têm rastreio próprio e ficam de fora.
  if (window.__infoStoreWhatsAppConversionReady) return;
  window.__infoStoreWhatsAppConversionReady = true;

  const ADS_ID = 'AW-17655084144';
  const CONVERSAO_ATENDIMENTO = 'AW-17655084144/ViRHCJSnuZQdEPDozOJB';
  const HOSTS = new Set(['wa.me', 'api.whatsapp.com', 'web.whatsapp.com']);
  const JA_RASTREADOS = '[data-assistance-lead-position], [data-rental-lead-position]';
  const ultimoClique = new WeakMap();

  const gtag = (...args) => {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    window.gtag(...args);
  };

  const marketingPermitido = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy ? privacy.marketingAllowed() : false;
    } catch (erro) {
      console.error('[InfoStore] conversão WhatsApp: falha ao ler a permissão de cookies', erro);
      return false;
    }
  };

  let tagPronta = false;
  const garantirTag = () => {
    if (tagPronta) return;
    tagPronta = true;
    const carregada = [...document.scripts].some((s) => /googletagmanager\.com\/gtag\/js/.test(s.src));
    if (!carregada) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_ID);
      document.head.appendChild(script);
      gtag('js', new Date());
    }
    gtag('config', ADS_ID, { send_page_view: false });
  };

  const ehWhatsApp = (link) => {
    try {
      const url = new URL(link.getAttribute('href'), window.location.href);
      return HOSTS.has(url.hostname.toLowerCase());
    } catch (_) {
      return false;
    }
  };

  const aoClicar = (evento) => {
    if (!(evento.target instanceof Element)) return;
    const link = evento.target.closest('a[href]');
    if (!link || !ehWhatsApp(link) || link.closest(JA_RASTREADOS)) return;

    const agora = Date.now();
    if (agora - (ultimoClique.get(link) || 0) < 2000) return;
    ultimoClique.set(link, agora);

    if (!marketingPermitido()) return;
    try {
      garantirTag();
      gtag('event', 'conversion', { send_to: CONVERSAO_ATENDIMENTO, transport_type: 'beacon' });
    } catch (erro) {
      console.error('[InfoStore] conversão WhatsApp: falha ao enviar', erro);
    }
  };

  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (erro) => {
    if (erro) console.error('[InfoStore] conversão WhatsApp: API de consentimento indisponível', erro);
  });
  document.addEventListener('click', aoClicar, { capture: true });
  document.addEventListener('auxclick', aoClicar, { capture: true });
})();
